import { render, staticRenderFns } from "./pitcher.vue?vue&type=template&id=1df06166&scoped=true"
import script from "./pitcher.vue?vue&type=script&lang=js"
export * from "./pitcher.vue?vue&type=script&lang=js"
import style0 from "./pitcher.vue?vue&type=style&index=0&id=1df06166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df06166",
  null
  
)

export default component.exports